//////////////////////////////////////////////////////////////////////
//
//  09/26/18
//  src/containers/MainNotFound404.js
//
//  This file is the top level MainNotFound404 javascript file.
//

import React, { Component } from "react";
import './MainNotFound404.css';

class MainNotFound404 extends Component {
  render() {
    var currentYear = ( new Date().getFullYear() > 2017 ) ? ( " - " + new Date().getFullYear() ) : "" ;
    var lastMod = "Last update: " + document.lastModified;

    return (
      <div className="MainNotFound">
        <h1>404 - Not Found</h1>

        <br />
        <br />
        <br />
        <h3>The page you are looking for has not been found.</h3>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      
        <div id="MainNotFoundCopyright">
          <small>&nbsp;Copyright <strong>LNP Software</strong> 2018{ currentYear } <br /> { lastMod }</small>
        </div>
          
      </div>
    );
  }
}

export default MainNotFound404;



// WEBPACK FOOTER //
// ./src/containers/MainNotFound404.js